import { PhoneNumberHelper } from "@swivl-mono/helpers";
import { z } from "zod";

export const addUserSchema = z.object({
  name: z.string().min(1, "Name is required"),
  email: z.email("Invalid email address"),
  phoneNumber: z
    .string()
    .min(1, "Phone number is required")
    .refine((val) => !!PhoneNumberHelper.isPhoneNumberValid(val), { message: "Enter a valid phone number" }),
  locationId: z.string().optional()
});

export type AddUserFormData = z.infer<typeof addUserSchema>;
